module.exports = __webpack_public_path__ + "identify_sensors_icon.271b538542a7db13aa79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/identify_sensors_icon.svg
// module id = 1406
// module chunks = 3